module.exports = __webpack_public_path__ + "img/homensde18a60anos.f0880d2a.png";